var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12.1 14 16 10 16 10H8C8 10 11.9 14 12 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07857 9.61148C7.23482 9.24091 7.59785 9 8.00001 9H16C16.4022 9 16.7652 9.24091 16.9214 9.61148C17.0777 9.98204 16.9968 10.4102 16.716 10.6981C15.4503 11.9947 14.2058 13.3141 12.886 14.5563C12.6366 14.791 12.3608 15 12 15C11.6392 15 11.3634 14.791 11.1141 14.5563C9.7957 13.3155 8.54918 11.9942 7.28476 10.6989L7.28401 10.6981C7.00326 10.4102 6.92232 9.98204 7.07857 9.61148Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/Caret.276ef04b1c542b0c59f540cfd7cd4464.svg";
export { ForwardRef as ReactComponent };